export const VARIANT_QUERY = `
  availableForSale
  id
  title
  image {
    transformedSrc(preferredContentType: WEBP, maxWidth: 190)
  }
  selectedOptions {
    name
    value
  }
  priceV2 {
    amount
    currencyCode
  }
  compareAtPriceV2 {
    amount
    currencyCode
  }
  unitPrice {
    amount
    currencyCode
  }
  unitPriceMeasurement {
    referenceValue
    referenceUnit
  }
  product {
    id
    title
    tags
    productType
    vendor
    handle
    relatedProducts: metafield(namespace: "my_fields", key: "related_products") {
      value
    }
    componentCount: metafield(namespace: "custom", key: "component_count") {
      value
    }
    collections(first: 20) {
    edges {
      node {
        id
        title
      }
    }
  }
  }
  sku
  weight
  weightUnit
`;

export const CART_QUERY = `
  id
  buyerIdentity {
    countryCode
  }
  attributes {
    key
    value
  }
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
  }
  lines(first: 250) {
    edges {
      node {
        id
        merchandise {
          ... on ProductVariant {
            ${VARIANT_QUERY}
            sellingPlanAllocations(first: 10) {
              edges {
                node {
                  sellingPlan {
                    id
                    name
                    options {
                      name
                      value
                    }
                  }
                }
              }
            }
          }
        }
        quantity
        attributes {
          key
          value
        }
        cost {
          amountPerQuantity {
            amount
            currencyCode
          }
        }
        discountAllocations {
          discountedAmount {
            amount
            currencyCode
          }
          ... on CartAutomaticDiscountAllocation {
            title
          }
        }
        sellingPlanAllocation {
          sellingPlan {
            id
            name
            options {
              name
              value
            }
          }
        }
      }
    }
  }
  createdAt
  updatedAt
  checkoutUrl
`;

export const PRODUCT_MEDIA_QUERY = `
query getProductMedia($id: ID!) {
  product(id: $id) {
    title
    media (first: 5) {
      edges {
        node {
          ... on MediaImage {
            id
            image {
              originalSrc
              altText
            }
          }
        }
      }
    }
  }
}
`;

export const PRODUCT_THUMBNAIL_MUTATION = `
mutation productCreateMedia($media: [CreateMediaInput!]!, $productId: ID!) {
  productCreateMedia(media: $media, productId: $productId) {
    media {
      mediaContentType
      status
    }
    product {
      id
      handle
    }
  }
}
`;

export const PRODUCT_IMAGES_DELETE_MUTATION = `
mutation productDeleteMedia($mediaIds: [ID!]!, $productId: ID!) {
  productDeleteMedia(mediaIds: $mediaIds, productId: $productId) {
    deletedMediaIds
    deletedProductImageIds
    product {
      title
    }
  }
}
`;

export const PRODUCT_DATA_QUERY = `
query getProductsByIds($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on Product {
    title
    id
    handle
    productType
    tags
    productVendor: metafield(namespace: "my_fields", key: "collection_name") {
      value
    }
    relatedProducts: metafield(namespace: "my_fields", key: "related_products") {
      value
    }
    componentCount: metafield(namespace: "custom", key: "component_count") {
      value
    }
    salePrice: metafield(namespace: "custom", key: "sale_price") {
      value
    }
    collections(first: 20) {
      edges {
        node {
          id
        }
      }
    }
    variants (first: 1) {
      edges {
        node {
          id
          sku
          price{
            amount
            currencyCode
          }
          compareAtPrice{
            amount
            currencyCode
          }
          unitPrice {
            amount
            currencyCode
          }
          unitPriceMeasurement {
            referenceValue
            referenceUnit
          }
          }
        }
      }
    }
  }
}
`;

export const PRODUCTS_QUERY = `  
query getAllProducts {
  products(first: 200) {
    edges {
      node {
        variants (first: 1) {
          edges {
            node {
              id
            }
          }
        }
        title
      }
    }
  }
}`;
